/** The application root. */

import type { ReactElement } from 'react';
import { Providers } from '@/app/providers';
import { AppRoutes } from '@/app/router';

/** Compose the providers and the routes. */
export default function App(): ReactElement {
  return (
    <Providers>
      <AppRoutes />
    </Providers>
  );
}
